import { useLocation, Redirect } from 'quartz-routing/react-router';
import { EmbeddedContentPage } from '../components/EmbeddedContentPage';
import { Paths } from '../constants/Paths';
import { usePayInvoice } from '../hooks/usePayInvoice';
import { buildEmbeddedInvoiceUrl } from '../utils/invoiceUrls';
import { jsx as _jsx } from "react/jsx-runtime";
export function InvoiceDetailsPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const invoiceUrl = params.get('url');
  const invoiceNumber = params.get('invoiceNumber');
  const invoiceId = Number(params.get('invoiceId'));
  const canHandlePaymentClick = Number.isSafeInteger(invoiceId) && invoiceId > 0;
  const {
    payInvoice,
    loading: isPayLoading
  } = usePayInvoice();
  if (!invoiceUrl) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: Paths.INVOICES
    });
  }
  return /*#__PURE__*/_jsx(EmbeddedContentPage, {
    src: canHandlePaymentClick ? buildEmbeddedInvoiceUrl(invoiceUrl, window.location.origin) : invoiceUrl,
    title: "Invoice",
    breadcrumbs: [{
      label: 'invoiceDetails.breadcrumb.invoices',
      href: Paths.INVOICES
    }, {
      label: invoiceNumber ? 'invoiceDetails.breadcrumb.invoiceNumber' : 'invoiceDetails.breadcrumb.invoiceDetails',
      options: invoiceNumber ? {
        invoiceNumber
      } : undefined
    }],
    subscreen: "invoice-details",
    onWindowMessage: msg => {
      var _msg$data;
      if (((_msg$data = msg.data) === null || _msg$data === void 0 ? void 0 : _msg$data.event) === 'PAYMENT_BUTTON_CLICKED' && canHandlePaymentClick && !isPayLoading) {
        payInvoice(invoiceId, {
          invoiceDetailsPath: `${location.pathname}${location.search}`,
          invoiceNumber: invoiceNumber || undefined
        });
      }
    }
  });
}